import React, {useState} from "react";
import DesignData from "../../../resources/DesignTab/design_data.json";
import {Box, Button, Flex, Grid, GridItem, Text} from "@chakra-ui/react";
import {ChevronDownIcon, ChevronUpIcon} from "@chakra-ui/icons";
import DesignModal from "./DesignModal";
import {FiEdit} from "react-icons/fi";
import {RiDeleteBin7Line} from "react-icons/ri";

const TechnologySection = ({label, technologies, setTechnologies, resetTechnology}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [currentEdit, setCurrentEdit] = useState(0);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const onClose = () => {
        setIsEdit(false);
        setModalOpen(false);
    }

    const onOpen = () => {
        setModalOpen(true);
    }

    const addTechnology = (selectedTech, inputs) => {
        if (technologies.find(technology => technology.label === selectedTech)?.isAdded) {
            alert(`Cannot add ${selectedTech}, as it is already added.`);
            return;
        }

        const updatedTechnologies = technologies.map(technology => {
            if (technology.label === selectedTech) {
                return {...technology, isAdded: true, inputs: inputs};
            } else
                return technology;
        });

        setTechnologies(updatedTechnologies);
        onClose();
    }

    const handleModalSubmit = (selectedTech, inputs) => {
        if (isEdit)
            editTechnology(currentEdit, selectedTech, inputs);
        else
            addTechnology(selectedTech, inputs);
    }

    const editTechnology = (recordIndex, selectedTech, inputs) => {

        let updatedTechnologies = [...technologies];

        if (technologies[recordIndex].label !== selectedTech) {
            if (technologies.find(technology => technology.label === selectedTech).isAdded) {
                alert(`Cannot add ${selectedTech}, as it is already added!`);
                return;
            }
            updatedTechnologies[recordIndex] = resetTechnology(updatedTechnologies[recordIndex]);
        }

        updatedTechnologies = updatedTechnologies.map(technology => {
            if (technology.label === selectedTech) {
                return {...technology, isAdded: true, inputs: inputs};
            } else
                return technology;
        });

        setTechnologies(updatedTechnologies);
        onClose();
    }

    const handleEdit = (recordIndex) => {
        setCurrentEdit(recordIndex);
        setIsEdit(true);
        onOpen();
    }

    const deleteTechnology = (recordIndex) => {
        const updatedTechnologies = [...technologies];
        updatedTechnologies[recordIndex] = resetTechnology(updatedTechnologies[recordIndex]);
        setTechnologies(updatedTechnologies);
    }

    return (
        <Box px={4} mb={4} py={4} borderWidth={"2px"} borderRadius={"md"}>
            <Flex justify="space-between" align="center" cursor={"pointer"}>
                <Text userSelect={"none"} fontSize={"xl"} fontWeight={"bold"}>{label}</Text>
                <Box>
                    {!isCollapsed && <Button mr={2} onClick={onOpen} isDisabled={technologies.findIndex(x => !x.isAdded) === -1}>+</Button>}
                    <Button onClick={toggleCollapse}>
                        {isCollapsed ? <ChevronDownIcon/> : <ChevronUpIcon/>}
                    </Button>
                </Box>
                <DesignModal isOpen={modalOpen} onClose={onClose} handleAddTech={handleModalSubmit} items={technologies} isEdit={isEdit} currentRecordIdx={currentEdit}/>
            </Flex>
            {!isCollapsed && (
                <Grid templateColumns="repeat(auto-fill, minmax(400px, 1fr))" gap={4} mt={2}>
                    {technologies.find(technology => technology.isAdded) ? (
                        technologies.map((technology, index) => {
                            if (technology.isAdded) {
                                return <GridItem key={index}><ItemCard data={technology}
                                                                       handleDelete={() => deleteTechnology(index)}
                                                                       handleEdit={() => handleEdit(index)}/></GridItem>
                            }
                        })
                    ) : (
                        <GridItem><EmptyItemsCard label={label.toLowerCase()}/></GridItem>
                    )}
                </Grid>
            )}
        </Box>
    );
};

const EmptyItemsCard = ({label}) => {
    return (
        <Flex
            justify="space-between"
            align="center"
            p={4}
            borderWidth="1px"
            borderRadius="md"
            mb={2}
        >
            <Text>No {label} currently added</Text>
        </Flex>
    );
};

const ItemCard = ({data, handleDelete, handleEdit}) => {
    return (
        <Flex
            justify="space-between"
            align="center"
            p={4}
            borderWidth="1px"
            borderRadius="md"
            mb={2}
        >
            <Text userSelect={"none"}>{data.label}</Text>
            <Box>
                <Button colorScheme="yellow" mr={2} onClick={handleEdit}><FiEdit/></Button>
                <Button colorScheme="red" onClick={handleDelete}><RiDeleteBin7Line/></Button>
            </Box>
        </Flex>
    )
};

export default TechnologySection;